import { Division, EmptyState, Flex, Icons, Spin } from "@ir/ui";
import { useParams } from "react-router";
import { AppConfig } from "@src/config/AppConfig";
import { ConfigPortalCredentialsDataProvider } from "@src/presentation/providers/config/ConfigPortalCredentialsDataProvider";
import { ConfigDeductionSlaConfigsDataProvider } from "@src/presentation/providers/config/ConfigDeductionSlaConfigsDataProvider";
import { useConfigBrand } from "../ConfigBrandContext";
import { ConfigPortalCredentialsFooter } from "../utils/ConfigPortalCredentialsFooter";
import { ConfigDeductionSlaConfigsFooter } from "../utils/ConfigDeductionSlaConfigsFooter";
import { ConfigPortalCredentialsPage } from "./ConfigPortalCredentialsPage";
import { ConfigDeductionSlaConfigsPage } from "./ConfigDeductionSlaConfigsPage";
import { isConfigSection } from "../configNav.config";

export const ConfigSectionRouter = () => {
  const { section } = useParams<{ section?: string }>();
  const { brand, isBrandSelected, isLookupLoading, isLookupReady } =
    useConfigBrand();

  if (!isConfigSection(section)) {
    return (
      <Division className="config-section">
        <EmptyState
          icon={Icons.Settings}
          title="Section not available"
          description="This Config section is not implemented yet."
        />
      </Division>
    );
  }

  if (isLookupLoading || !isLookupReady || !isBrandSelected || !brand) {
    return (
      <Division className="config-section">
        <Flex align="center" justifyContent="center" className="py-6">
          <Spin tip="Loading brand..." spinning />
        </Flex>
      </Division>
    );
  }

  const defaultPageSize = AppConfig.getDefaultPaginationLimit();
  const brandKey = brand.brandKey;

  if (section === "portal-credentials") {
    return (
      <ConfigPortalCredentialsDataProvider
        key={`portal-credentials-${brandKey}`}
        brandKey={brandKey}
        defaultPageSize={defaultPageSize}
      >
        <Division className="config-section-shell">
          <ConfigPortalCredentialsPage />
          <ConfigPortalCredentialsFooter />
        </Division>
      </ConfigPortalCredentialsDataProvider>
    );
  }

  if (section === "sla-config") {
    return (
      <ConfigDeductionSlaConfigsDataProvider
        key={`sla-config-${brandKey}`}
        brandKey={brandKey}
        defaultPageSize={defaultPageSize}
      >
        <Division className="config-section-shell">
          <ConfigDeductionSlaConfigsPage />
          <ConfigDeductionSlaConfigsFooter />
        </Division>
      </ConfigDeductionSlaConfigsDataProvider>
    );
  }

  return null;
};
